
import card from '~/mixins/card'
import { rxDeductibleScope } from '~/util/aep-recommendation'
import { deductibleTiersText } from '~/util/deductible-tiers'
import { toMoneyNumber } from '~/util/string'
import { tablePeriod } from '~/util/drug-table'
export default {
    mixins: [card],
    props: {
        magicUrl: {
            type: String,
            default: '/'
        },
        mode: {
            type: [String, Object],
            default: 'default'
        },
        aep: {
            type: Boolean,
            default: null
        },
        index: {
            type: Number,
            default: null
        },
        comboIndex: {
            type: Number,
            default: null
        },
    },
    computed: {
        pdpDeductibleScope () {
            return rxDeductibleScope(toMoneyNumber(this.pdpPlan?.drug_deductible), this.pdpPlan?.drug_deductible_applicable_tiers, this.pdpPlan?.drug_deductible_all_tiers)
        },
        pdpTiersText () {
            return deductibleTiersText(this.pdpPlan?.drug_deductible_applicable_tiers, this.pdpPlan?.drug_deductible_all_tiers)
        },
        pdpOrMapdTiersText () {
            return deductibleTiersText(this.pdpOrMapd?.drug_deductible_applicable_tiers, this.pdpOrMapd?.drug_deductible_all_tiers)
        },
        planPharmacyQuarterly () {
            return tablePeriod(this.planPharmacy0) === 'quarter'
        },
    },
}
